module.exports = __webpack_public_path__ + "static/logo-2124a15548ffe8d9e74d896fd7a2992e.png";